export class Branch {
    id: number;
    name: string;
    code: string;
    address: string;
    city_id: number;
    city_name: string;
    country_id: number;
    country_name: string;
    sales_tax: number;
    sales_tax2: number;
    company_id: number;
    company_name: string;
    currency_id: number;
    currency_name: string;
    currency_code: string;
    currency_symbol: string;
    currency_exchange_rate_euro: number;
    // New approach
    currency: string;
    exchange_rate_euro: number;
    // End
    invoice_starting_num: number;
    invoice_series: string;
    id_no: string;
    vat_no: string;
    bank: string;
    account: string;
    swift: string;
    contact_name: string;
    contact_email: string;
    contact_phone: string;
    contact_mobile: string;
    contact_fax: string;
    contact_address: string;
    contact_city_id: number;
    contact_city_name: string;
    contact_country_id: number;
    contact_country_name: string;
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/branch.ts